import { isPlainObject as rawIsPlainObject, reduce } from 'lodash';
const isPlainObject = (arg)=>rawIsPlainObject(arg);
export const rejectTypenameDeep = (input)=>// use isPlainObject here to prevent reducing functions, class instances,
    // and other object-like constructs. isPlainObjectTypeguard just adds a
    // typeguard so that TS knows that if true, then the input is an object
    // (the lodash function doesn't include this for some reason)
    isPlainObject(input) || Array.isArray(input) ? reduce(input, (acc, value, key)=>{
        if (key !== '__typename') {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string | number' can't be used to index type 'unknown'. | No index signature with a parameter of type 'string' was found on type 'unknown'.
            acc[key] = rejectTypenameDeep(value);
        }
        return acc;
    }, Array.isArray(input) ? [] : {}) : input;

//# sourceMappingURL=rejectTypenameDeep.js.map